import { ComponentType } from '@angular/cdk/portal';
import { ChangeDetectionStrategy, Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-confirmdialog',
	templateUrl: './confirmdialog.component.html',
	styleUrls: ['./confirmdialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ConfirmdialogComponent implements OnInit {
	public okReturnData: any;
	public cancelReturnData: any;
	public heading: string;
	public content: string;
	public contentComponent: ComponentType<any>;
	public contentContext: any;
	public okButtonText: string;
	public cancelButtonText: string;

	constructor(
		public dialogRef: MatDialogRef<ConfirmdialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private injector: Injector,
	) {}

	ngOnInit(): void {
		Object.assign(this, this.data);
		if (this.data.contentComponent) {
			this.contentContext = this.data.contentContext || {};
		}
	}

	isContentComponent(): boolean {
		return !!this.contentComponent;
	}

	onOkClick() {
		this.dialogRef.close(this.okReturnData || true);
	}

	onCancelClick() {
		this.dialogRef.close(this.cancelReturnData || false);
	}
}
